module.exports = __webpack_public_path__ + "img/pic2.cb2eb3d2.png";